import { BUAN_AUTHORIZED_STAFF } from '../config/admin';
import { supabase } from '../config/supabase';
import { isAuthorizedAdminAddress, normalizeAddress } from './auth';

export interface PortalAccessResolution {
  allowed: boolean;
  source: 'admin_bypass' | 'allowlisted_wallets';
  reason?: string;
}

export const resolvePortalAccess = async (
  address?: string | null
): Promise<PortalAccessResolution> => {
  const normalizedAddress = normalizeAddress(address);
  if (!normalizedAddress) {
    return {
      allowed: false,
      source: 'allowlisted_wallets',
      reason: 'invalid_wallet_address',
    };
  }

  if (isAuthorizedAdminAddress(normalizedAddress, BUAN_AUTHORIZED_STAFF)) {
    return {
      allowed: true,
      source: 'admin_bypass',
    };
  }

  const { data, error } = await supabase
    .from('allowlisted_wallets')
    .select('wallet_address, active')
    .eq('wallet_address', normalizedAddress)
    .eq('active', true)
    .maybeSingle();

  if (error) {
    throw new Error(error.message || 'allowlisted_wallets lookup failed');
  }

  return {
    allowed: Boolean(data?.wallet_address),
    source: 'allowlisted_wallets',
    reason: data?.wallet_address ? undefined : 'wallet_not_allowlisted',
  };
};